<!-- ── EDIT: Project meeting feedback ──────────────────────────────────────── -->
<div *ngIf="!read_only" class="action-panel pmeeting-panel">
  <div class="action-panel-header pmeeting-header" (click)="opened = !opened" style="cursor:pointer;">
    <i class="fa fa-comments-o" style="margin-right:6px;"></i>
    {{ title }}
    <i class="fa pmeeting-chevron" [ngClass]="opened ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
  </div>

  <div *ngIf="opened" class="action-panel-body">
    <p *ngIf="toSubmit" class="action-panel-desc">
      Please take a few minutes to share your feedback on the advice provided by the HSbooster expert.
    </p>

    <form-error-summary [errors]="fieldErrors" (jumpTo)="jumpToField($event)"></form-error-summary>

    <div class="pmeeting-questions">
      <ng-container *ngFor="let question of questions">
        <open-question *ngIf="isOpenQuestion(question)"
                       [type]="'project_survey_meeting'"
                       [question]="getQuestionKey(question)"
                       [editor]="getQuestion(question)"
                       [description]="getQuestionDescription(question)"
                       [submitted]="submitted">
        </open-question>
        <tick-box *ngIf="!isOpenQuestion(question)"
                  [fields]="question"
                  [type]="'project_survey_meeting'"
                  [description]="getQuestionDescription(question)"
                  [submitted]="submitted">
        </tick-box>
      </ng-container>
    </div>

    <div *ngIf="toSubmit" class="pmeeting-actions">
      <button (click)="confirm()" class="btn btn-primary action-btn">
        <i class="fa fa-paper-plane"></i> Submit feedback
      </button>
    </div>
  </div>
</div>

<!-- ── READ-ONLY: Project meeting summary ──────────────────────────────────── -->
<div *ngIf="read_only" class="action-panel pmeeting-panel">
  <div class="action-panel-header pmeeting-header" (click)="opened = !opened" style="cursor:pointer;">
    <i class="fa fa-comments" style="margin-right:6px;"></i>
    Project feedback summary
    <i class="fa pmeeting-chevron" [ngClass]="opened ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
  </div>

  <div *ngIf="opened" class="action-panel-body">
    <div class="summary-list" *ngIf="getKeys().length > 0">
      <div class="summary-row" *ngFor="let key of getKeys()">
        <div class="summary-key">{{ key }}</div>
        <div class="summary-val">
          <i *ngIf="summary[key] === true" class="fa fa-check"></i>
          <span *ngIf="summary[key] !== true">
            <div [innerHTML]="summary[key]"></div>
          </span>
        </div>
      </div>
    </div>
    <p *ngIf="getKeys().length === 0" class="text-muted" style="margin:0;font-style:italic;">
      The project's meeting feedback is not ready yet.
    </p>
  </div>
</div>

<svg class="inline-svg">
  <symbol id="check" viewBox="0 0 12 10">
    <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
  </symbol>
</svg>

<simple-alert [message]="alertMessage" [alert]="alertType" [(show)]="showAlert"></simple-alert>